export default __webpack_public_path__ + "static/media/ddsu5168_2p_blue_rs485_gw214.8f3b2d06.jpg";